<template>
  <div class="recruitment-card">
    <img
      class="recruitment-card-icon"
      :src="inviteTypeConfig.icon || ''"
    >
    <div class="recruitment-card-content">
      <div class="recruitment-card-content-title">
        {{ inviteTypeConfig.text || "" }}
      </div>
      <div class="recruitment-card-content-info">
        账号：{{ value.phone || "" }}
      </div>
      <div class="recruitment-card-content-info">
        拉新日期：{{ value.createTime || "" }}
      </div>
    </div>
  </div>
</template>

<script>
import IconDirectRecruitment from '@/assets/img/chargingVoucher/icon-direct-recruitment.png';
import IconIndirectRecruitment from '@/assets/img/chargingVoucher/icon-indirect-recruitment.png';

export default {
  name: 'RecruitmentCard',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      inviteTypeDict: {
        DIRECT: {
          text: '直接拉新',
          icon: IconDirectRecruitment
        },
        INDIRECT: {
          text: '间接拉新',
          icon: IconIndirectRecruitment
        }
      }
    };
  },
  computed: {
    inviteTypeConfig() {
      if (!this.value?.inviteType) return {};
      return this.inviteTypeDict[this.value.inviteType];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.recruitment-card {
  width: 100%;
  height: 192px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 32px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .recruitment-card-icon {
    width: 96px;
    height: 96px;
    object-fit: contain;
    margin-right: 28px;
  }
  .recruitment-card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .recruitment-card-content-title {
      font-size: 32px;
      color: #383838;
      font-weight: bold;
      line-height: 45px;
      margin-bottom: 4px;
    }
    .recruitment-card-content-info {
      font-size: 28px;
      color: #787878;
      letter-spacing: 0.42px;
      font-weight: 400;
      margin-bottom: 4px;
      line-height: 40px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
